/**
 * Gestionnaire de thèmes ErgoMind
 */

export const THEMES = {
    CLASSIQUE: 'classique',
    DYNAMIQUE: 'dynamique'
};

// Récupère le thème stocké ou définit 'classique' par défaut
export const getStoredTheme = () => {
    return localStorage.getItem('ergomind_theme') || THEMES.CLASSIQUE;
};

// Sauvegarde le choix de l'utilisateur
export const setStoredTheme = (themeName) => {
    localStorage.setItem('ergomind_theme', themeName);
};

// Cette fonction sera appelée dans App.js
export const applyTheme = (themeName) => {
    // On ajoute une classe au body pour que le CSS puisse cibler : .theme-classique ou .theme-dynamique
    document.body.className = `theme-${themeName}`;
    
    // Import dynamique des fichiers CSS
    if (themeName === THEMES.DYNAMIQUE) {
        import('./dynamique/style.css');
    } else {
        import('./classique/style.css');
    }
};